import { assertNever } from '@deltasierra/shared';
import * as React from 'react';

export type DateTimeFormatType = 'date' | 'datetime-local' | 'time';

export const useDateTimeFormat = (type: DateTimeFormatType = 'datetime-local'): string =>
    React.useMemo(() => {
        switch (type) {
            case 'date':
                return 'YYYY-MM-DD';
            case 'time':
                return 'HH:mm:ss';
            case 'datetime-local':
                return 'YYYY-MM-DDTHH:mm:ss';
            default:
                throw assertNever(type);
        }
    }, [type]);
